import { useEffect, useState } from "react";
import { getMasterCompanyNames } from "../../../services/gsuite/sheets";

/**
 * Custom hook to fetch and manage master company names.
 * @returns {{ companyNames: string[], fetchCompanyNames: Function }}
 */
function useCompanyNames() {
  const [companyNames, setCompanyNames] = useState([]);

  const fetchCompanyNames = async () => {
    const companyNamesRes = await getMasterCompanyNames();
    const companyNamesJson = await companyNamesRes.json();
    setCompanyNames(companyNamesJson.company_names.sort());
  };

  useEffect(() => {
    fetchCompanyNames();
  }, []);

  return {
    companyNames,
    fetchCompanyNames,
  };
}

export default useCompanyNames;
